// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Pvy8","col":"styles_col__1mgJx"};